import React from 'react';
import Icon from '../../../components/AppIcon';

const RuleStatsPanel = () => {
  const statsData = [
    {
      title: "Total Active Rules",
      value: "247",
      change: "+12",
      changeType: "increase",
      icon: "BookOpen"
    },
    {
      title: "Most Triggered",
      value: "FDIC Disclosure",
      subtitle: "89 violations this month",
      icon: "AlertTriangle"
    },
    {
      title: "Compliance Rate",
      value: "94.2%",
      change: "+2.1%",
      changeType: "increase",
      icon: "TrendingUp"
    },
    {
      title: "Pending Updates",
      value: "8",
      subtitle: "Regulatory changes",
      icon: "Clock"
    }
  ];

  const topViolations = [
    {
      rule: "FDIC Disclosure Requirements",
      violations: 89,
      trend: "up",
      severity: "high"
    },
    {
      rule: "Truth in Lending Act",
      violations: 67,
      trend: "down",
      severity: "medium"
    },
    {
      rule: "Fair Credit Reporting",
      violations: 45,
      trend: "up",
      severity: "high"
    },
    {
      rule: "Consumer Privacy Rights",
      violations: 32,
      trend: "stable",
      severity: "low"
    },
    {
      rule: "Anti-Money Laundering",
      violations: 28,
      trend: "down",
      severity: "high"
    }
  ];

  const getSeverityColor = (severity) => {
    switch (severity) {
      case 'high':
        return 'text-error bg-error/10';
      case 'medium':
        return 'text-warning bg-warning/10';
      case 'low':
        return 'text-success bg-success/10';
      default:
        return 'text-muted-foreground bg-muted';
    }
  };

  const getTrendIcon = (trend) => {
    switch (trend) {
      case 'up':
        return { name: 'TrendingUp', color: 'text-error' };
      case 'down':
        return { name: 'TrendingDown', color: 'text-success' };
      default:
        return { name: 'Minus', color: 'text-muted-foreground' };
    }
  };

  return (
    <div className="space-y-6">
      {/* Stats Cards */}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {statsData?.map((stat, index) => (
          <div key={index} className="bg-card border border-border rounded-lg p-4">
            <div className="flex items-start justify-between">
              <div className="flex-1">
                <p className="text-sm text-muted-foreground mb-1">{stat?.title}</p>
                <p className="text-2xl font-semibold text-foreground">{stat?.value}</p>
                {stat?.subtitle && (
                  <p className="text-xs text-muted-foreground mt-1">{stat?.subtitle}</p>
                )}
                {stat?.change && (
                  <div className={`flex items-center mt-2 text-xs ${
                    stat?.changeType === 'increase' ? 'text-success' : 'text-error'
                  }`}>
                    <Icon 
                      name={stat?.changeType === 'increase' ? 'ArrowUp' : 'ArrowDown'} 
                      size={12} 
                      className="mr-1" 
                    />
                    {stat?.change}
                  </div>
                )}
              </div>
              <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center">
                <Icon name={stat?.icon} size={20} className="text-primary" />
              </div>
            </div>
          </div>
        ))}
      </div>
      {/* Top Violations */}
      <div className="bg-card border border-border rounded-lg">
        <div className="p-4 border-b border-border">
          <h3 className="text-lg font-semibold text-foreground">Most Triggered Rules</h3>
          <p className="text-sm text-muted-foreground">Rules with highest violation frequency this month</p>
        </div>
        <div className="p-4">
          <div className="space-y-3">
            {topViolations?.map((violation, index) => (
              <div key={index} className="flex items-center justify-between p-3 bg-muted/30 rounded-lg">
                <div className="flex-1">
                  <div className="flex items-center space-x-2 mb-1">
                    <span className="text-sm font-medium text-foreground">{violation?.rule}</span>
                    <span className={`px-2 py-1 text-xs font-medium rounded-full ${getSeverityColor(violation?.severity)}`}>
                      {violation?.severity}
                    </span>
                  </div>
                  <p className="text-xs text-muted-foreground">{violation?.violations} violations</p>
                </div>
                <div className="flex items-center space-x-2">
                  <span className="text-lg font-semibold text-foreground">{violation?.violations}</span>
                  <Icon 
                    name={getTrendIcon(violation?.trend)?.name} 
                    size={16} 
                    className={getTrendIcon(violation?.trend)?.color} 
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default RuleStatsPanel;